module.exports = __webpack_public_path__ + "static/media/NR.bbc94de9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/NR.svg
// module id = 2231
// module chunks = 7